(function(){
var $=function(s,r){return (r||document).querySelector(s)};
function wrap(){return document.getElementById('shopify-section-cart-drawer')}
function setCount(n){document.querySelectorAll('[data-cart-count]').forEach(function(e){e.textContent=n})}
function refresh(open){
 return fetch('/?sections=cart-drawer').then(function(r){return r.json()}).then(function(j){
  var d=document.createElement('div');d.innerHTML=j['cart-drawer'];var n=d.firstElementChild,w=wrap();
  if(w&&n){w.innerHTML=n.innerHTML;var dr=$('[data-drawer]',w);if(open&&dr)requestAnimationFrame(function(){dr.classList.add('open')})}
 }).then(function(){return fetch('/cart.js').then(function(r){return r.json()})}).then(function(c){setCount(c.item_count)});
}
document.addEventListener('submit',function(e){
 var f=e.target;if(!(f.matches&&f.action&&f.action.indexOf('/cart/add')>-1))return;
 e.preventDefault();var b=f.querySelector('button[type=submit]'),t=b&&b.innerHTML;if(b){b.disabled=true;b.textContent='Adding…'}
 fetch('/cart/add.js',{method:'POST',body:new FormData(f)}).then(function(r){if(!r.ok)throw 0;return r.json()})
 .then(function(){return refresh(true)})
 .then(function(){if(b){b.innerHTML=t;b.disabled=false}})
 .catch(function(){f.submit()});
});
document.addEventListener('click',function(e){
 var t=e.target;
 if(t.closest('[data-cart-open]')&&wrap()&&location.pathname!=='/cart'){e.preventDefault();var d=$('[data-drawer]');if(d)d.classList.add('open');return}
 if(t.closest('[data-close]')){var dr=$('[data-drawer]');if(dr)dr.classList.remove('open');return}
 var q=t.closest('[data-qty]');
 if(q){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:+q.dataset.line,quantity:+q.dataset.qty})}).then(function(){return refresh(true)});return}
 if(t.closest('[data-burger]')){$('[data-nav]').classList.toggle('open');return}
 var th=t.closest('.thumbs button');if(th){var i=$('#mainimg');if(i){i.src=th.dataset.src;i.removeAttribute('srcset')}}
});
document.addEventListener('keydown',function(e){if(e.key==='Escape'){var d=$('[data-drawer]');if(d)d.classList.remove('open')}});
document.addEventListener('change',function(e){var sel=e.target.closest&&e.target.closest('[data-variants]');if(!sel)return;
 var o=sel.selectedOptions[0],p=$('[data-price]'),a=$('[data-atc]');p.textContent=o.dataset.price;a.disabled=o.dataset.avail!=='true';a.textContent=a.disabled?'Sold out':'Add to cart'});
// hero slideshow
var h=$('[data-slides]');
if(h){var s=h.querySelectorAll('.slide'),dots=h.querySelectorAll('.dots i'),i=0,tm;
 var sp=parseInt(h.getAttribute('data-speed')||'6',10);
 function go(n){s[i].classList.remove('on');if(dots[i])dots[i].classList.remove('on');i=(n+s.length)%s.length;s[i].classList.add('on');if(dots[i])dots[i].classList.add('on')}
 function play(){clearInterval(tm);if(sp>0&&s.length>1)tm=setInterval(function(){go(i+1)},sp*1000)}
 var pv=$('[data-prev]',h),nx=$('[data-next]',h);if(pv)pv.onclick=function(){go(i-1);play()};if(nx)nx.onclick=function(){go(i+1);play()};play()}
})();
